import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-profession',
	templateUrl: './profession.component.html',
	styleUrls: ['./profession.component.css']
})
export class ProfessionComponent implements OnInit {
	professionForm: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	modalTitle: any;
	categoryList: any;
	btnTitle: any;
	selectedCategoryId: any;
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	profession: any;
	surveyCategoryList: any;
	category_id: any;
	professionLan:any = [];

	constructor(
		private commonService: CommonService, 
		private authService: AuthService,
		private router: Router,
		private validationService: ValidationService,
		private pagerService: PagerService
	) { }


	ngOnInit() {
		//this.commonService.setTitle();
		$(".navbar-brand").text("Profession");
	//	$(".navbar-brand").text("category_id");
		this.professionForm = new FormGroup({
			profession: new FormControl("", Validators.compose([Validators.required])),
			profession_arabic: new FormControl("", Validators.compose([null])),
			profession_hindi: new FormControl("", Validators.compose([null])),
			profession_latin: new FormControl("", Validators.compose([null])),
			profession_french: new FormControl("", Validators.compose([null])),
			 category_id: new FormControl("",Validators.compose([
				Validators.required
			])),
		});
	
		// this.professionForm = new FormGroup({
		// 	category_id: new FormControl("", Validators.compose([
		// 		Validators.required,
		// 	])),
		// });
		this.limit = 10;
		this.getCategoryList(1, this.limit);
		this.initialiseSurvey();
			
	}

	initialiseSurvey = function () {
	// Get survey category list
	this.authService.getSurveyCategoryList().subscribe(data => {
		if (data.success) {
			// debugger;;
		
			this.surveyCategoryList = data.category;
			setTimeout(() => {
				//if (obj.survey_category_id)
					//this.professionForm.controls['category_id'].setValue(data._id);
			//	 $('.select_lang').removeClass('is-empty');
			}, 10);
		}
	});
	}

	// Get profession List
	getCategoryList = function (pageNo, limit) {
		        // // debugger;;;
		this.commonService.process();
		this.authService.getProfessionList(pageNo, limit).subscribe(data => {
			if (data.success) {
				// debugger;;
				this.categoryList = data.profession;
				this.total = data.total;
				console.log(data)
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			console.log(data.profession)
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.categoryList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getCategoryList(page, this.limit);
		}
	}

	// addprofession
	addCategory = function () {
		this.isActivatedAdd = true;
		this.isActivatedEdit = false;
		this.isActivatedDelete = false;
		this.modalTitle = "Add Category";
		this.btnTitle = "Save";
		this.selectedCategoryId = "";
		this.professionForm.reset();
	}

	// Update selected profession
	updateSelectedCategory = function (category) {
		// debugger;;

		this.isActivatedAdd = false;
		this.isActivatedEdit = true;
		this.isActivatedDelete = false;
		this.modalTitle = "Update Category";
		this.btnTitle = "Update";
		this.selectedCategoryId = category._id;
		
		this.professionForm.controls['profession'].setValue(category.profession);
		this.professionForm.controls['profession_arabic'].setValue(category.profession_arabic);
		this.professionForm.controls['profession_hindi'].setValue(category.profession_hindi);
		this.professionForm.controls['profession_latin'].setValue(category.profession_latin);
		this.professionForm.controls['profession_french'].setValue(category.profession_french);

		this.professionForm.controls['category_id'].setValue(category.category_id._id);
	}

	// Delete Selected profession
	deleteSelectedCategory = function (category) {
	
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Category";
		this.btnTitle = "Yes";
		this.selectedCategoryId = category._id;
		this.category = category;
	}

	// manage new profession
	manageProfession = function (professionForm) {
		
         // debugger;;;
		if (this.professionForm.valid && this.isActivatedAdd) {
			this.btnTitle = "Saving...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			        // // debugger;;;
			this.authService.manageProfession(professionForm, "add").subscribe(data => {
				if (data.success) {
					jQuery.growl.notice({ title: 'Success', message: data.message });
					this.getCategoryList(1, this.limit);
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.professionForm.valid && this.isActivatedEdit) {
			professionForm._id = this.selectedCategoryId;
			this.btnTitle = "Updating...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageProfession(professionForm, "update").subscribe(data => {
				if (data.success) {	
					this.getCategoryList(this.pageNo, this.limit);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else if (this.isActivatedDelete) {
			professionForm._id = this.selectedCategoryId;
			this.btnTitle = "Deleting...";	
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageProfession(professionForm, "delete").subscribe(data => {
				if (data.success) {	
					this.getCategoryList(this.pageNo, this.limit);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.professionForm);
		}
	}

	viewLanguageCategory = function (data){
		
		console.log(data);
		this.professionLan = data.profession_languages ? data.profession_languages : [];
	}


}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/profession/profession.component.ts